import { call, put } from 'redux-saga/effects';
import { getAuditEvents, getAuditUsers } from './audit.backend';
import {
    fetchAuditEventsFail,
    fetchAuditEventsSuccess,
    fetchAuditUsersFail,
    fetchAuditUsersSuccess
} from './actions';
import { makeErrorPayload } from '../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../shared/toast/redux/actions';

export function* fetchAuditEventsSaga(action) {
    try {
        const response = yield call(getAuditEvents, action.payload);
        yield put(fetchAuditEventsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchAuditEventsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

/*
  The names are a convenience: without them an event says who did it by the id, as it does for someone who is gone. So a failure says
  nothing of its own (the events that are read at the same time say it when the server is not there).
*/
export function* fetchAuditUsersSaga() {
    try {
        const response = yield call(getAuditUsers);
        yield put(fetchAuditUsersSuccess(response.data));
    } catch (error) {
        yield put(fetchAuditUsersFail(makeErrorPayload(error)));
    }
}
